import { AddressType } from 'api/types';

function normalize(value: string): string {
  return value.trim().toLowerCase();
}

export const addressesMatch = (a: AddressType, b: AddressType): boolean =>
  normalize(a.street_1) === normalize(b.street_1) &&
  normalize(a.street_2) === normalize(b.street_2) &&
  normalize(a.city) === normalize(b.city) &&
  normalize(a.state) === normalize(b.state) &&
  normalize(a.zip_code) === normalize(b.zip_code);

export default addressesMatch;
